import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirportIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirportGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.2748 20.6655H8.85287C8.70639 20.6655 8.56771 20.6016 8.4725 20.4902C8.37777 20.3789 8.33627 20.2314 8.35922 20.0874L9.28207 14.272H6.02084L4.85971 15.9268C4.76645 16.0601 4.61362 16.1397 4.45053 16.1397H2.49985C2.34311 16.1397 2.19565 16.0659 2.10092 15.9409C2.00619 15.8159 1.97592 15.6538 2.01889 15.5029L3.0267 11.9526L2.01986 8.50049C1.97591 8.34912 2.00521 8.18604 2.09994 8.06055C2.19418 7.93457 2.34262 7.86035 2.49984 7.86035H4.45052C4.61165 7.86035 4.76302 7.93799 4.85677 8.06885L6.04622 9.72803H9.30745L8.35921 3.91504C8.33577 3.77002 8.37679 3.62256 8.472 3.51074C8.56673 3.39892 8.70638 3.33447 8.85286 3.33447H11.2747C11.4828 3.33447 11.6693 3.46338 11.7425 3.6582L14.0321 9.72802H18.8846C19.3153 9.72802 19.7415 9.83886 20.1175 10.0478L21.2205 10.6616C21.7054 10.9321 21.9969 11.4248 22.0003 11.9795C22.0033 12.5342 21.7176 13.0303 21.2357 13.3057L20.1302 13.9375C19.7484 14.1562 19.3133 14.272 18.8719 14.272H13.9798L11.744 20.3384C11.6712 20.5352 11.4842 20.6655 11.2748 20.6655ZM9.43832 19.6655H10.9261L13.162 13.5991C13.2347 13.4023 13.4217 13.272 13.6312 13.272H18.8719C19.139 13.272 19.4027 13.2021 19.6336 13.0698L20.7396 12.4375C20.9764 12.3022 21.0008 12.0762 21.0003 11.9853C20.9998 11.894 20.9725 11.6685 20.7342 11.5356L19.6312 10.9219C19.4037 10.7949 19.1454 10.728 18.8846 10.728H13.6864C13.4784 10.728 13.2918 10.5991 13.2186 10.4043L10.9291 4.33446H9.44077L10.389 10.1475C10.4125 10.2925 10.3714 10.4399 10.2762 10.5518C10.1815 10.6636 10.0418 10.728 9.89536 10.728H5.7894C5.62827 10.728 5.4769 10.6504 5.38315 10.5195L4.1937 8.86034H3.16636L4.0272 11.8105C4.05357 11.9009 4.05406 11.9966 4.02818 12.0874L3.16148 15.1397H4.19029L5.35142 13.4849C5.44468 13.3516 5.59751 13.272 5.7606 13.272H9.86753C10.014 13.272 10.1527 13.3359 10.2479 13.4473C10.3426 13.5586 10.3841 13.7061 10.3612 13.8501L9.43832 19.6655Z"
        fill="#696969"
      />
    </svg>
  );
};

export default AirportIcon;
